<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h3 class="panel-title">
        Orders by Channel
        <CalculationTooltip text="How each order's customer found you. A Facebook or Instagram ad only counts as Paid Social when its link has UTM tags; otherwise it shows as Organic Social." />
      </h3>
    </div>
    <div class="panel-body">
      <BarChart v-if="chartData" :key="chartKey" :data="chartData" :options="chartOptions" data-testid="marketing-report-channels" />
      <p v-else class="text-muted">No orders in these dates.</p>
    </div>
  </div>
</template>

<script>
import { Bar as BarChart } from 'vue-chartjs';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import CalculationTooltip from '../../scheduling-dashboard/components/CalculationTooltip.vue';
import { CHANNEL_LABELS } from './marketingChannels';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default {
  name: 'MarketingChannelChart',
  components: { BarChart, CalculationTooltip },
  props: {
    byChannel: { type: Array, required: true }
  },
  data: function() {
    return {
      chartKey: 0
    };
  },
  watch: {
    byChannel: function() {
      this.chartKey++;
    }
  },
  computed: {
    chartData() {
      if (!this.byChannel || this.byChannel.length === 0) return null;
      return {
        labels: this.byChannel.map(function(row) { return CHANNEL_LABELS[row.channel]; }),
        datasets: [
          {
            label: 'Orders',
            data: this.byChannel.map(function(row) { return row.orders; }),
            backgroundColor: '#337ab7'
          }
        ]
      };
    },
    chartOptions() {
      return {
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: { display: false }
        },
        scales: {
          x: {
            beginAtZero: true,
            ticks: { precision: 0 }
          }
        }
      };
    }
  }
};
</script>
